"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Charts = void 0;
const Charts_yaml_component_1 = __importDefault(require("./Charts.yaml?component"));
exports.Charts = Charts_yaml_component_1.default;
